import React from 'react';

// SVGs originais fornecidos — cor dinâmica via currentColor
// Tipos disponíveis: car, motorcycle, truck (pickup), suv
// Barco, trator e outro removidos nesta versão

const SVG_PROPS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52.53 53.11",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinejoin: "round",
  strokeLinecap: "round",
};

const CarroSVG = () => (
  <svg {...SVG_PROPS}>
    <g>
 <g>
 <g>
 <line stroke-miterlimit="10" x1="36.8" y1="44.9" x2="16.8" y2="44.9"/>
 <line stroke-miterlimit="10" x1="30.8" y1="37.9" x2="27.8" y2="37.9"/>
 <line stroke-miterlimit="10" x1="7.8" y1="36.9" x2="4.8" y2="36.9"/>
 <circle stroke-miterlimit="10" cx="41.3" cy="44.9" r="4"/>
 <circle stroke-miterlimit="10" cx="12.8" cy="44.9" r="4"/>
 <line x1="25.8" y1="33.9" x2="25.8" y2="27.9"/>
 <polyline points="40.8 33.9 16.8 33.9 19.35 28.67"/>
 <path stroke-miterlimit="10" d="M8.8,44.9h-1c-2.21,0-4-1.79-4-4v-2l1-2v-2c0-1.1.9-2,2-2h2l4.61-4.03c2.19-1.91,5-2.97,7.9-2.97h5.28c2.72,0,5.37.93,7.5,2.63l6.71,5.37c8.86,1.62,9,3.92,9,3.92v5.08c0,1.1-.9,2-2,2h-3"/>
 </g>
 <line x1="46.8" y1="38.9" x2="49.8" y2="38.9"/>
 </g>
 </g>
  </svg>
);

const MotoSVG = () => (
  <svg {...SVG_PROPS}>
    <g>
 <circle stroke-miterlimit="10" cx="41.04" cy="41.01" r="7"/>
 <circle stroke-miterlimit="10" cx="41.04" cy="41.01" r="3"/>
 <circle stroke-miterlimit="10" cx="9.04" cy="41.01" r="7"/>
 <circle stroke-miterlimit="10" cx="9.04" cy="41.01" r="3"/>
 <line x1="26.04" y1="19.01" x2="31.04" y2="20.01"/>
 <line stroke-miterlimit="10" x1="17.79" y1="34.01" x2="9.04" y2="41.01"/>
 <line x1="26.04" y1="34.01" x2="18.04" y2="34.01"/>
 <line x1="26.04" y1="38.01" x2="19.04" y2="38.01"/>
 <line stroke-miterlimit="10" x1="41.04" y1="41.01" x2="35.95" y2="29.58"/>
 <line stroke-miterlimit="10" x1="33.02" y1="22.99" x2="31.04" y2="20.01"/>
 <path d="M31.04,16.01s9.13,3.32,10.77,11.3c.13.61-.34,1.19-.96,1.2-1.68.02-3.35.38-4.9,1.08"/>
 <path d="M37.29,19.87c-1.15,1.3-3.56,2.86-4.27,3.12-1.21.45-2.5.6-3.36.78-2.04.43-3.52,1.64-5.41,2.52-2.2,1.02-5.1.9-8.22-.28-3.35-1.47-9.21-2.3-12.42.42-.22.18-.22.52-.01.73l1.78,1.78c.34.34.8.49,1.28.42,7.05-.27,11.79,2.96,12.79,10.27.27,1.96,2.01,3.38,3.99,3.38h7c.15,0,.27-.14.24-.29-.09-.56-.14-1.13-.14-1.71,0-4.28,2.56-7.96,6.23-9.6"/>
 </g>
  </svg>
);

const PickupSVG = () => (
  <svg {...SVG_PROPS}>
    <g>
 <g>
 <line stroke-miterlimit="10" x1="7.02" y1="36.75" x2="4.02" y2="36.75"/>
 <line stroke-miterlimit="10" x1="37.02" y1="44.75" x2="17.02" y2="44.75"/>
 <circle stroke-miterlimit="10" cx="41.52" cy="44.25" r="4.5"/>
 <circle stroke-miterlimit="10" cx="13.02" cy="44.25" r="4.5"/>
 <line stroke-miterlimit="10" x1="30.02" y1="36.75" x2="27.02" y2="36.75"/>
 <line stroke-miterlimit="10" x1="50.02" y1="36.75" x2="47.02" y2="36.75"/>
 <line x1="40.82" y1="44.96" x2="42.23" y2="43.55"/>
 <line x1="12.32" y1="44.96" x2="13.73" y2="43.55"/>
 <path d="M41.02,32.75H4.02v10c0,1.1.9,2,2,2h2"/>
 <path d="M23.02,44.75v-21h8.2c1.14,0,2.23.49,2.99,1.34l6.81,7.66,7.22.8c1.01.11,1.78.97,1.78,1.99v8.21c0,.55-.45,1-1,1h-3"/>
 <line x1="28.02" y1="32.75" x2="28.02" y2="23.75"/>
 </g>
 </g>
  </svg>
);

const SuvSVG = () => (
  <svg {...SVG_PROPS}>
    <g>
 <g>
 <line stroke-miterlimit="10" x1="35.44" y1="45.41" x2="19.44" y2="45.41"/>
 <circle stroke-miterlimit="10" cx="39.94" cy="44.91" r="4.5"/>
 <circle stroke-miterlimit="10" cx="15.44" cy="44.91" r="4.5"/>
 <line stroke-miterlimit="10" x1="32.44" y1="37.41" x2="29.44" y2="37.41"/>
 <line stroke-miterlimit="10" x1="48.44" y1="37.41" x2="45.44" y2="37.41"/>
 <g>
 <path d="M44.44,45.41h3c.55,0,1-.45,1-1v-8.23c0-1.01-.75-1.86-1.75-1.98l-6.25-.78-6.81-7.66c-.76-.85-1.85-1.34-2.99-1.34H8.94l-2.5,9v10c0,1.1.9,2,2,2h2"/>
 <line x1="29.44" y1="24.41" x2="6.44" y2="24.41"/>
 </g>
 <line x1="39.24" y1="45.62" x2="40.65" y2="44.21"/>
 <line x1="14.74" y1="45.62" x2="16.15" y2="44.21"/>
 <line x1="6.44" y1="33.41" x2="40.44" y2="33.41"/>
 <line x1="26.44" y1="45.41" x2="26.44" y2="24.41"/>
 <line x1="12.44" y1="33.41" x2="12.44" y2="24.41"/>
 <path stroke-miterlimit="10" d="M6.44,40.41h-2c-1.1,0-2-.9-2-2v-5c0-1.1.9-2,2-2h3"/>
 </g>
 </g>
  </svg>
);

export default function VehicleIllustration({ type = 'car', color = '#1a1a1a', size = 120 }) {
  const wrapStyle = {
    width: size,
    height: size,
    color: color,          // currentColor herda daqui
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  };

  const svgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  };

  const renderSVG = () => {
    switch (type) {
      case 'car':        return <CarroSVG style={svgStyle} />;
      case 'motorcycle': return <MotoSVG style={svgStyle} />;
      case 'truck':      return <PickupSVG style={svgStyle} />;
      case 'suv':        return <SuvSVG style={svgStyle} />;
      // Fallback para tipos sem ilustração
      default:           return <CarroSVG style={svgStyle} />;
    }
  };

  return (
    <div style={wrapStyle}>
      {renderSVG()}
    </div>
  );
}

export const VEHICLE_COLORS = [
  { name: 'Preto', value: '#1a1a1a' },
  { name: 'Branco', value: '#888' },
  { name: 'Prata', value: '#6b7280' },
  { name: 'Vermelho', value: '#dc2626' },
  { name: 'Azul', value: '#2563eb' },
  { name: 'Verde', value: '#16a34a' },
  { name: 'Amarelo', value: '#ca8a04' },
  { name: 'Laranja', value: '#ea580c' },
  { name: 'Marrom', value: '#92400e' },
  { name: 'Verde Petróleo', value: '#1a6b5c' },
];

export const VEHICLE_TYPES = [
  { value: 'car', label: 'Carro', emoji: '🚗' },
  { value: 'motorcycle', label: 'Moto', emoji: '🏍️' },
  { value: 'truck', label: 'Pickup', emoji: '🛻' },
  { value: 'suv', label: 'SUV', emoji: '🚙' },
];
